//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Mechatronics.js";
import "../Mechatronics/Mechatronics.PhysicsConstraintBuilder.js";
import "../Mechatronics/Mechatronics.SelectCollisionSensorList.js";
import "../Mechatronics/Mechatronics.SelectRigidBody.js";
import "../no/SelectNXObjectList.js";
import "../no/SelectObject.js";
import "../no/SelectObjectList.js";
let d=[[[1,"CollisionSensor",0,"Mechatronics.SelectCollisionSensorList",0],[0,"ExecuteOnce",1,0],[1,"RigidBody",0,"Mechatronics.SelectRigidBody",0],[1,"Source",0,"SelectNXObjectList",0],[0,"SourceType",1,0]],[],[]];
SPLM.Mechatronics.ObjectTransformerBuilder = class extends SPLM.Mechatronics.PhysicsConstraintBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Mechatronics.ObjectTransformerBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Mechatronics.ObjectTransformerBuilder.TransformSourceType = Object.freeze({
    "AnyObject" : "AnyObject", "OnlySelected" : "OnlySelected"});

export default SPLM;